<template>
  <component :is="tag" :class="['button', '--arrow', {'--dark': dark,'--grey': grey, '--reverse': reverse, '--small': small}]">
    <Icon id="arrow"/>
  </component>
</template>

<script>
import {Icon} from '@/components/global'

export default {
  name: 'ArrowButton',
  components: {Icon},
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    grey: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'button'
    }
  }
}
</script>